import store from '@/store'
/**
 * @Description:  按钮权限控制 ps: 表格中按钮在重新渲染时需先移除再显示，否则钩子函数inserted不会执行
 * @param:
 * @Author: ZhangBin
 * @Date 2019-11-13 13:48
 */
export default {
  inserted(el, binding, vnode) {
    const { value } = binding;
    const roles = store.getters && store.getters.userFunction ? JSON.parse(store.getters.userFunction) : [];

    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value;

      const hasPermission = roles.some(role => {
        return permissionRoles.includes(role)
      });

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`need roles!`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/permission.js